const homeEn = {
  hero: {
    title: 'Welcome to Grameen Bazar',
    subtitle: 'Find what you need',
  },
  search: {
    placeholderDefault: 'Search products...',
    typewriterPlaceholders: ['Chachkoir Bazar', 'General Store', 'Alim Store', 'Malabar Spinach'],
  },
  partners: {
    heading: 'Our Partners',
    subheading: 'Collaborating with trusted organizations',
  },
};

export default homeEn;




